var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgColumn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8767 4.26725V2.41689H13.21V4.91689H10.71V6.58356L13.21 6.58357V9.08356L14.8769 9.08357V6.58357L17.3767 6.58356V4.91689H14.8769L14.8767 4.26725Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0435 4.24978V7.25024H10.9566V16.7498C10.9566 17.21 10.5835 17.5831 10.1233 17.5831H8.03996C7.57972 17.5831 7.20662 17.21 7.20662 16.7498V5.08311C7.20662 4.62287 7.57972 4.24978 8.03996 4.24978H10.0435Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.79 16.7498V7.25024H12.5435V9.75024H15.5395V16.7498C15.5395 17.21 15.1664 17.5831 14.7061 17.5831H12.6233C12.1631 17.5831 11.79 17.21 11.79 16.7498Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.62329 5.08311C2.62329 4.62287 2.99639 4.24978 3.45662 4.24978H5.53996C6.00019 4.24978 6.37329 4.62287 6.37329 5.08311V16.7498C6.37329 17.21 6.00019 17.5831 5.53996 17.5831H3.45662C2.99639 17.5831 2.62329 17.21 2.62329 16.7498V5.08311Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgColumn);
export default __webpack_public_path__ + "static/media/Column.3e030d35903c375d30feef72e155a613.svg";
export { ForwardRef as ReactComponent };